/* global gsap */

export default class BurgerButton {
	constructor() {
		this.buttonWrapper = document.querySelector('.burger-button-wrapper');
		if (!this.buttonWrapper) return;
		this.buttonLines = this.buttonWrapper.querySelectorAll('.burger-button span');
		this.offCanvas = document.getElementById(this.buttonWrapper.dataset.target);
		if (!this.offCanvas) return;
		this.isWorking = false;
		this.events();
	}

	onBurgerButtonClicked() {
		if (this.isWorking) return false;
		this.isWorking = true;

		if (!this.offCanvas.classList.contains('active')) {
			window.dispatchEvent(new Event('burgerButton.open'));
		} else {
			window.dispatchEvent(new Event('burgerButton.close'));
		}
		return true;
	}

	onMainMenuOpen() {

		this.isWorking = false;
	}

	onMainMenuClose() {
		this.isWorking = false;
	}

	events() {
		this.buttonWrapper.addEventListener('click', this.onBurgerButtonClicked.bind(this), false);
		window.addEventListener('mainMenu.open', this.onMainMenuOpen.bind(this), false);
		window.addEventListener('mainMenu.close', this.onMainMenuClose.bind(this), false);
	}

}
